<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "circle-check" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 23 22'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M7.37467 10.9997L10.1247 13.7497L15.6247 8.24967M20.6663 10.9997C20.6663 16.0623 16.5623 20.1663 11.4997 20.1663C6.43706 20.1663 2.33301 16.0623 2.33301 10.9997C2.33301 5.93706 6.43706 1.83301 11.4997 1.83301C16.5623 1.83301 20.6663 5.93706 20.6663 10.9997Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>